import React, { useState } from 'react';
import { Col, Container, Row } from 'reactstrap';
import logo from '../../../assets/logo/LOGO_CAPBAY_VERTICAL_CROPPED.png';
import LoadingSpinner from '../../../components/LoadingSpinner';
import { useDict } from '../../../contexts/LanguageContext';
import WizardForm from './WizardForm';

const RegistrationStepsWizardForm = () => {
    const dict = useDict();

    const [isLoading, setIsLoading] = useState(false);

    return (
        <>
            {isLoading && <LoadingSpinner />}
            <Container>
                <Row>
                    <Col md={12}>
                        <div>
                            <h3 className="account__title">
                                <span
                                    className="account__logo account__logo-style"
                                >
                                    <img
                                        src={logo}
                                        alt="logo"
                                        style={{
                                            width: '200px', marginLeft: 'auto', marginRight: 'auto', display: 'block',
                                        }}
                                    />
                                </span>
                            </h3>
                        </div>
                        <div>
                            <WizardForm
                                isLoading={isLoading}
                                setIsLoading={setIsLoading}
                            />
                        </div>
                        <div className="account__or_divide">
                            <div className="regulated-by-text">
                                {dict.regulatedByText}
                            </div>
                        </div>
                    </Col>
                </Row>
            </Container>
        </>
    )
};

export default RegistrationStepsWizardForm;
